module.exports = "./img/ce0b045704b715291e3609ec8a186113.jpg";